/* import __COLOCATED_TEMPLATE__ from './market-input-time-picker.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
const TimeRegExp24Hour = /(?<hour>^[01]?\d|2[0-4]):(?<minute>[0-5]\d$)/;
/**
 * Parse a formatted time string using a 24-hour clock.
 * This returns null when the string format does not match `timeRegExp24Hour`
 *
 * 00:00 => { hour: 0, minute: 0 }
 * 06:30 => { hour: 6, minute: 30 }
 * 12:00 => { hour: 12, minute 0 }
 * 18:30 => { hour: 18, minute 30 }
 *
 * @param displayValue The displayed time
 * @returns The parsed time
 */
export function parseTime24Hour(displayValue) {
  const match = displayValue.match(TimeRegExp24Hour);
  if (match?.groups) {
    const hour = Number.parseInt(match.groups.hour, 10) % 24;
    if (hour < 0 || hour > 23) {
      return null;
    }
    return {
      hour,
      minute: Number.parseInt(match.groups.minute, 10)
    };
  }
  return null;
}
let MarketInputTimePicker = (_class = class MarketInputTimePicker extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  /**
   * The value of the time input is always in 24-hour format that includes leading zeros: hh:mm,
   * regardless of the input format, which is likely to be selected based on the user's locale
   * (or by the user agent)
   *
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/time#time_value_format
   */
  get inputValue() {
    const {
      value
    } = this.args;
    if (!value) {
      return '';
    }
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    };
    // the month-day-year doesn't matter since we're only formatting time
    const instant = new Date();
    instant.setHours(value.hour);
    instant.setMinutes(value.minute);
    return this.intl.formatTime(instant, options);
  }
  setTime(event) {
    const displayTime = event.detail.value;
    const value = parseTime24Hour(displayTime);
    this.args.onChange(value);
  }
  onBlur() {
    this.args.onBlur && this.args.onBlur();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlur", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBlur"), _class.prototype)), _class);
export { MarketInputTimePicker as default };